import React from 'react';

import ProfileDetails from '@/core/components/ProfileDetails';
import Store from '@/core/lib/new-architecture/store';
import { useRouterContext } from '@/core/lib/router/router.context';

interface DonationDetailsProps {}

export const DonationSide: React.FC<DonationDetailsProps> = () => {
  const { query } = useRouterContext();
  const { data: donation } = Store.donation.useDonation(Number(query.id));

  const user = donation?.getUser();
  if (!user) return null;

  return (
    <div className="w-full bg-bg-primary p-5 lg:p-3">
      <ProfileDetails user={user} variant="small" canShare={false} />
    </div>
  );
};
